import styled from 'styled-components';

export const Label = styled.label`
&&& {
    font-size: 0.875rem;
    font-weight: 800;
    padding-bottom: 1rem;
    display: flex;
}
`;
